import React, { useState } from "react";
import {
  Container,
  Typography,
  Card,
  CardContent,
  Button,
  Grid,
  Snackbar,
  TextField,
} from "@mui/material";
import LoginForm from "../../molecules/LoginForm";
import "./style.css";
import logo from "../../../imgs/logo-final.png";
import { Link } from "react-router-dom";
import { loginFunc, verify2FA } from "../../../api/services/services";
import MuiAlert from "@mui/material/Alert";
import { connect } from "react-redux";
import { login, logout } from "../../../modules/redux/reducers/authActions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import successImg from "../../../imgs/succes.svg";
import useMediaQuery from "@mui/material/useMediaQuery";

const LoginPage = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [verify, setVerify] = useState(false);
  const [token, setToken] = useState("");

  const [digits, setDigits] = useState(["", "", "", "", "", ""]);
  const [success, setSuccess] = useState(false);

  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const inputProps = {
    style: {
      height: "50px", // Set the height to 40 pixels
      width: "50px",
      textAlign: "center",
      fontSize: "20px",
      paddingLeft: "5px",
    },

    maxLength: 1,
  };

  const inputRefs = React.useRef([]);

  const handleChange = (index, value) => {
    if (value.match(/^\d{0,1}$/)) {
      const updatedDigits = [...digits];
      updatedDigits[index] = value;
      setDigits(updatedDigits);

      if(value == "" && index > 0) {
        inputRefs.current[index - 1].focus();
      }

      if (index < 5 && value !== "") {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && digits[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  // Confirming 2FA
  const confirm2Fa = () => {
    let code = "";
    for (let i = 0; i < digits.length; i++) {
      code = code + digits[i];
    }
    const body = {
      code: code,
    };

    const activeToken = token || localStorage.getItem("fa-token");
    verify2FA(activeToken, body)
      .then((response) => {
        // setSuccess(true);
        setSnackbarMessage("Login successful!");
        setOpenSnackbar(true);
        localStorage.setItem("shelLoginToken", response?.data?.data?.token);
        localStorage.setItem(
          "shelUserData",
          JSON.stringify(response?.data?.data?.admin)
        );

        const currentTime = new Date();
        localStorage.setItem("loginTime", currentTime);
        setTimeout(() => {
          // dispatch(login());
          window.location.pathname = "/";
        }, 500);
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 1002) {
          setSnackbarMessage("Token has been expired");
          setOpenSnackbar(true);
        } else {
          setSnackbarMessage(error?.response?.data?.message);
          setOpenSnackbar(true);
        }
      });
  };

  const handleLogin = (formData) => {
    // console.log("Login data:", formData);

    const body = {
      email: formData?.email,
      password: formData?.password,
    };

    loginFunc(body)
      .then((response) => {
        const data = response?.data?.data;
        localStorage.setItem("fa-token", data?.token);
        setToken(data?.token);
        
        if (data?.requires_2fa_setup) {
           navigate("/two-factor-auth", { state: { token: data?.token } });
        } else {
           setVerify(true);
        }
      })
      .catch((error) => {
        console.error("Login Error", error);
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);
      });
  };

  const isConfirmButtonDisabled =
    digits[0].length == 0 ||
    digits[1].length == 0 ||
    digits[2].length == 0 ||
    digits[3].length == 0 ||
    digits[4].length == 0 ||
    digits[5].length == 0;

  return (
    <div className="login-split-container">
      {/* ... Left Panel ... */}
      <div className="brand-panel">
        <div className="brand-content">
          <Typography variant="h1" className="brand-title">
            Shelozon Digital
          </Typography>
          <Typography variant="h5" className="brand-tagline">
            Orchestrating the future of logistics with seamless precision.
          </Typography>
        </div>
      </div>

      {/* Right Panel */}
      <div className="form-panel">
        <Container maxWidth="xs" className="form-container">
          {!verify ? (
            <>
              {/* ... Login Form ... */} 
              <div className="form-header">
                <Typography variant="h4" className="form-title">
                  Welcome Back
                </Typography>
                <Typography variant="body1" className="form-desc">
                  Please enter your details to sign in
                </Typography>
              </div>
              
              <LoginForm onSubmit={handleLogin} />

              <div style={{ textAlign: 'right' }}>
                 <Link to="/forget-password" style={{ color: '#6366f1', textDecoration: 'none', fontWeight: 600, fontSize: '0.875rem' }}>
                  Forgot Password?
                </Link>
              </div>
            </>
          ) : (
            <>
              {success == false ? (
                 <div className="fa-container">
                    <div className="form-header" style={{ textAlign: 'center' }}>
                       <Typography variant="h4" className="form-title">
                         Two-Factor Auth
                       </Typography>
                       <Typography variant="body1" className="form-desc">
                         Enter the 6-digit code from your authenticator app
                       </Typography>
                    </div>
                    
                    <div className="d-flex align-items-center justify-content-center mb-4 mt-4 pin-input-container" style={{ gap: '8px' }}>
                      {digits.map((digit, index) => (
                        <TextField
                          key={index}
                          inputRef={(el) => (inputRefs.current[index] = el)}
                          variant="outlined"
                          size="small"
                          type="text"
                          value={digit}
                          onChange={(e) => handleChange(index, e.target.value)}
                          onKeyDown={(e) => handleKeyDown(index, e)}
                          sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                                backgroundColor: '#fff',
                                boxShadow: '0 2px 5px rgba(0,0,0,0.05)'
                            },
                             '& input': { 
                                 textAlign: 'center', 
                                 fontSize: '24px', 
                                 fontWeight: 'bold',
                                 padding: isSmallScreen ? '10px' : '12px',
                                 width: isSmallScreen ? '20px' : '24px'
                             }
                          }}
                        />
                      ))}
                    </div>

                    <Button
                      type="button"
                      variant="contained"
                      className="submit-btn"
                      onClick={confirm2Fa}
                      disabled={isConfirmButtonDisabled}
                      fullWidth
                    >
                      Verify Identity
                    </Button>
                 </div>
              ) : (
                  <div className="success-container" style={{ textAlign: 'center' }}>
                     <img
                        src={successImg}
                        alt="success"
                        width="80"
                        height="80"
                        className="mb-4"
                     />
                     <Typography variant="h5" className="success-title mb-2">
                        Login Successful
                     </Typography>
                     <Typography variant="body1" className="form-desc">
                        Redirecting to dashboard...
                     </Typography>
                     
                     <Button
                      type="submit"
                      variant="contained"
                      className="submit-btn mt-4"
                      onClick={() => {
                        dispatch(login());
                        navigate("/");
                      }}
                      fullWidth
                    >
                      Continue
                    </Button>
                  </div>
              )}
            </>
          )}
        </Container>
      </div>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Adjust the duration as needed
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={
            snackbarMessage?.includes("successful") ? "success" : "error"
          }
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );

};

const mapStateToProps = (state) => ({
  isLoggedIn: state.auth.isLoggedIn,
});

const mapDispatchToProps = {
  login,
  logout,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
